import React from 'react'
import { isNumber } from 'lodash'

import Type from '../formItem/Type'
import InfoGroup from '../formItem/InfoGroup'
import Upload from '../formItem/Upload'
import Tags from '../formItem/Tags'
import Content from '../formItem/Content'
import Options from '../formItem/Options'
import SelectGroup from '../formItem/SelectGroup'
import Explanation from '../formItem/Explanation'

export const Sorting = ({ form, childrenIndex }) => {
    const prevPath = isNumber(childrenIndex) ? [childrenIndex] : []
    return (
        <>
            <Content prevPath={prevPath} />
            <Upload prevPath={prevPath} />
            <Options form={form} type="text" sorting childrenIndex={childrenIndex} prevPath={prevPath} />
            <SelectGroup form={form} prevPath={prevPath} />
            <Explanation prevPath={prevPath} />
        </>
    )
}

export default ({ form }) => (
    <>
        <Type type="Sorting" />
        <InfoGroup />
        <Tags />
        <Sorting form={form} />
    </>
)
